<template>
  <div class="sandMsgCon ticketMsgCon">
    <div class="msgBox">
      <div class="msgTemplate">
        <div class="sms_body_con">
          <div class="scroll-y">
<!--            <div class="advertTxt" v-if="params.isAdvertisement">{{ advertisementText.top }}</div>-->
            <v-textarea
              v-model="inputMessage"
              placeholder="メッセージを入力してください。                             90byte 超過すると自動的にLMSに切り替わります。"
              auto-grow
              rows="8"
              @input="byteCheck"
            >
            </v-textarea>
            <div class="advertTxt smallTxt" v-if="shortURL">{{shortURL}}</div>
          </div>
        </div>
        <div class="msgBtm">
          <div class="bytesTxt">
            <strong>{{ msgLengthStatus }}</strong> (<span>{{ calcByte }}</span>/{{ byteMaxLength }} bytes)
          </div>
        </div>
      </div>
      <div class="msgTypeBox">
        <table>
          <colgroup>
            <col style="width:22%" />
            <col style="width:78%" />
          </colgroup>
          <tbody>
          <tr>
            <th>テンプレート</th>
            <td>
              <v-select
                v-model="template"
                label="テンプレートを選択してください。"
                :items="templates"
                item-text="name"
                item-value="id"
                :disabled="templates.length < 1"
                @change="changeTemplate"
                class="UXselect smsTemplateSelector"
                :menu-props="{contentClass:'UXselectMenu'}"
                color="#ff8c8c"
                hide-details
                outline
                solo
                no-data-text="データがありません。"
              >
                <template v-slot:item="data">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ data.item.name }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </v-select>
            </td>
          </tr>
          <tr>
            <th>発信番号</th>
            <td>
              <v-select
                :items="brandNumbers"
                item-text="callBack"
                item-value="callBack"
                v-model="selectedBrandNumber"
                label="発信番号"
                class="UXselect"
                color="#ff8c8c"
                hide-details
                outline
                solo
                no-data-text="データがありません。"
              ></v-select>
            </td>
          </tr>
          <tr>
            <th>受信番号</th>
            <td>
              <v-text-field
                      v-model="destinationPhoneNumber"
                      placeholder="受信番号を入力してください。"
                      type="number"
                      class="UXinput UXicon-edit"
                      hide-details
                      outline
                      solo
              ></v-text-field>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="btn">
          <div class="msgCount" v-if="$targetMake.isSeller && !msgCountData.isUnlimitedMessageCountBrand">※ 無料SMS残り件数 ( <span class="colorBlue">{{ msgCountData.monthFreeSendCount }}</span> 件)</div>
          <v-btn round dark large color="#ff8c8c" class="UXbtn widthAuto" @click="massMessageSubmit">送信</v-btn>
          <tooltip
            text="チャット相談へ移動リンクを通じて<br />同じチケットで再インバウンドが可能です。"
            classes="UXicon-info_outlined"
            icon-color="#DCDCDC"
            :is-icon="true"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Tooltip from '@/components/tooltip'

export default {
  name: 'ticket_message',
  components: {
    Tooltip
  },
  props: {
    setSmsMessageAvailable: {
      type: Function
    },
    customerPhoneNumber: {
      type: String
    },
    ticketId: {
      type: Number
    },
    msgCountData: {
      type: Object
    }
  },
  data () {
    return {
      brands: [],
      brandId: '',
      brandName: '',
      brandNumbers: [],
      templates: [],
      template: '',
      selectedBrandNumber: '',
      destinationPhoneNumber: '',
      inputMessage: '',
      calcByte: 0,
      byteMaxLength: '90',
      calcByteStyle: 'black',
      calcByteText: 'SMSに転送されます。',
      msgLengthStatus: 'SMS',
      sendBtnClass: 'blue white--text cursor',
      shortURL: '',
      sendingSMS: false,
      displayId: ''
    }
  },
  computed: {
    ...mapGetters([
      'currentBrandId',
      'currentBrandName'
    ])
  },
  mounted () {
    if (this.$route.query.displayId) {
      this.displayId = this.$route.query.displayId.replace('#', '')
      this.initialize()
    }
  },
  watch: {
    customerPhoneNumber (newVal, oldVal) {
      this.destinationPhoneNumber = this.customerPhoneNumber !== '-' ? this.customerPhoneNumber : ''
    }
  },
  methods: {
    initialize () {
      this.axios.get('/api/agent/fetchBrands').then(result => {
        if (result.data.code !== 0) throw result.data.message
        const data = result.data.data
        this.brands = []
        data.forEach(brand => {
          this.brands.push({id: brand.id, name: brand.name})
        })
        if (this.currentBrandId) {
          this.brandId = this.currentBrandId
          this.brandName = this.currentBrandName
        } else {
          this.brandId = data[0].id
          this.brandName = data[0].name
        }

        this.clearData()
        this.getEnabledModule().then(() => {
          this.getShortURL()
        })
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => this.$alertMsg(errorMsg))
        .then(() => this.checkAvailability())
    },
    checkAvailability () {
      this.axios.get('/api/brand/isUsableModuleChannel', {
        params: {
          brandId: this.brandId,
          moduleName: 'MESSAGE',
          channelName: 'SMS'
        }
      }).then(result => {
        if (result.data.code === 0) {
          this.getChannelData()
        }
      })
    },
    getChannelData () {
      this.$http.get('/api/module/message/channels', {
        params: {
          brandId: this.brandId
        }
      }).then(result => {
        let raw = result.data
        if (raw.code === 0) {
          this.setSmsMessageAvailable()
          let smsData = raw.data.channels.filter(f => f.channelName === 'SMS')[0]
          this.brandNumbers = smsData.serviceInfos.map(m => m.tel)
          this.selectedBrandNumber = smsData.serviceInfos.map(m => m.tel)[0]
          this.templates = smsData.templates
        } else {
          throw result.data.message
        }
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => this.$alertMsg(errorMsg))
    },
    changeTemplate (data) {
      this.inputMessage = this.templates.filter(f => f.id === data)[0].content
      this.byteCheck()
    },
    charByteSize: function (ch) {
      if (ch == null || ch.length === 0) {
        return 0
      }

      var charCode = ch.charCodeAt(0)

      if (charCode <= 0x00007F) {
        return 1
      } else if (charCode <= 0x0007FF) {
        return 2
      } else if (charCode <= 0x00FFFF) {
        return 2
      } else {
        return 4
      }
    },
    changeStatusToSMS () {
      this.calcByteText = 'SMSに転送されます。'
      this.msgLengthStatus = 'SMS'
      this.calcByteStyle = 'black'
      this.sendBtnClass = 'blue white--text cursor'
      this.byteMaxLength = '90'
    },
    changeStatusToLMS () {
      this.calcByteText = 'LMSに転送されます。'
      this.msgLengthStatus = 'LMS'
      this.calcByteStyle = 'red'
      this.sendBtnClass = 'orange white--text cursor'
      this.byteMaxLength = '2000'
    },
    getByteLength (s) {
      if (s == null || s.length === 0) {
        return 0
      }
      var size = 0

      for (var i = 0; i < s.length; i++) {
        size += this.charByteSize(s.charAt(i))
      }

      return size
    },
    byteCheck () {
      const urlLength = this.getByteLength(this.shortURL)
      const enterLength = this.getByteLength('\n\n')

      if (this.inputMessage && this.inputMessage !== '') {
        const inputLength = this.getByteLength(this.inputMessage)
        this.calcByte = inputLength + urlLength + enterLength
        if (this.calcByte > 90) {
          this.changeStatusToLMS()
        } else {
          this.changeStatusToSMS()
        }
      } else {
        this.calcByte = urlLength + enterLength
        this.changeStatusToSMS()
      }
    },
    massMessageSubmit () {
      if (this.inputMessage === '') {
        this.$alertMsg('メッセージの内容がありません。')
        return false
      }
      if (this.calcByte > 2000) {
        this.$toasted.error('2,000 bytesまで入力可能です。')
        return false
      }

      if (!/^\d{3}\d{3,4}\d{4}$/g.test(this.destinationPhoneNumber.replace(/-/g, ''))) {
        this.$alertMsg('電話番号の形式が正しくありません。')
        return false
      }

      this.singlePhoneNumberSend()
    },
    singlePhoneNumberSend () {
      if (this.sendingSMS) return

      const regex = /(\u00a9|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g
      const removeEmojis = this.inputMessage.replace(regex, '')
      if (removeEmojis.length !== this.inputMessage.length) {
        this.$alertMsg('企業型テキストメッセージとカカオ通知トークは<br />通信会社の方針に従って<br />Emoji(😀)をサポートしていません。')
        return false
      }

      this.sendingSMS = true
      const message = this.inputMessage.concat('\n\n', this.shortURL)

      let param = new FormData()
      param.set('brandId', this.brandId)
      param.set('ticketId', this.ticketId)
      param.set('channelName', 'SMS')
      param.set('content', message)
      param.set('serviceTelNumber', this.selectedBrandNumber.replace(/-/g, ''))
      param.set('phoneNumbers', this.destinationPhoneNumber.replace(/-/g, ''))
      this.$http({
        method: 'POST',
        url: '/api/apps/message/send',
        timeout: 120000,
        data: param
      }).then((result) => {
        const { code, message, data } = result.data
        if (code === 0) {
          this.$alertMsg('文字の送信が完了しました。')
          this.initialize()
          if (this.$targetMake.isSeller) {
            this.$emit('sendMsgAndUpdateCount', {
              type: 'SMS',
              count: {
                isUnlimitedMessageCountBrand: data.isUnlimitedMessageCountBrand,
                monthFreeSendCount: data.monthFreeSendCount
              }})
          }
        } else if (code === -20027) {
          this.$toasted.error(message)
        } else if (code === -20034) {
          this.$alertMsg(message)
        } else {
          throw result.data.message
        }
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => {
          this.$alertMsg(this.$const.SYS_ERR)
        })
        .finally(() => {
          this.sendingSMS = false
        })
    },
    getEnabledModule () {
      return new Promise((resolve) => {
        this.$http.get('/api/module/check/enabledModule', {
          params: {
            brandId: this.brandId,
            moduleName: 'CHAT'
          }
        }).then(result => {
          let raw = result.data
          if (raw.code === 0) {
            if (raw.data) {
              resolve()
            }
          } else {
            this.$alertMsg(raw.message)
          }
        })
      })
    },
    getShortURL () {
      this.axios.get(`/gateway/ticket/shortenURL?displayId=${encodeURI(this.displayId)}`, {
      }).then(result => {
        if (result.data.code !== 0) throw result.data.message
        this.shortURL = result.data.data ? `▶ チャット相談に移動: ${result.data.data}` : ''
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => this.$alertMsg(this.$const.SYS_ERR))
        .then(() => this.setCalcByte())
    },
    clearData () {
      this.inputMessage = ''
      this.calcByte = 0
      this.calcByteStyle = 'black'
      this.calcByteText = 'SMSに転送されます。'
      this.msgLengthStatus = 'SMS'
      this.sendBtnClass = 'blue white--text cursor'
      this.shortURL = ''
      this.destinationPhoneNumber = this.customerPhoneNumber !== '-' ? this.customerPhoneNumber : ''
      this.template = ''
      this.templates = []
    },
    setCalcByte () {
      this.calcByte = this.getByteLength(this.shortURL)
      if (this.calcByte > 90) {
        this.changeStatusToLMS()
      } else {
        this.changeStatusToSMS()
      }
    }
  }
}
</script>

<style lang="scss">
.ticketMsgCon {
  .msgTypeBox {
    .btn {
      position: relative;
      .tooltip {
        position: absolute;
        top:51px;
        right:5px;
        .UXicon-info_outlined {
          font-size:28px;
        }
      }
      .msgCount {
        padding-bottom: 10px;
        font-size: 12px;
        line-height: 16px;
        font-weight: bold;
      }
    }
    .smsTemplateSelector {
      max-width: 212px;
      .v-select__selection {
        max-width: 160px!important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/fragments/ticket_message.vue